import { get } from 'lodash';

// local dependencies
import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/*************************************************************/

/**
 * @type {class}
 * @desc ActionListWidget defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { ActionListWidgetService } from 'services/transferQueueWidget';
 *
 * // create service instance and send/cancel request
 * const actionListWidgetService = new ActionListWidgetService();
 * const result = await actionListWidgetService.fetchData( '<user-id>' ); // fetch data
 * actionListWidgetService.cancel(); // cancel an active request
 */
export class ActionListWidgetService extends HttpService {

    // fetch call list data
    async fetchComponentData( { url = {}, data = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: get( response, 'body.component', {} ),
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }

}
